export {default as moment} from 'moment'

import moment from 'moment'

export const defaultRanges = {
  month: (date: moment.MomentInput) => ({
    start: moment(date).startOf('month').startOf('week').format('YYYY-MM-DD'),
    end: moment(date).endOf('month').endOf('week').format('YYYY-MM-DD')
  }),
  week: (date: moment.MomentInput) => ({
    start: moment(date).startOf('week').format('YYYY-MM-DD'),
    end: moment(date).endOf('week').format('YYYY-MM-DD')
  }),
  day: (date: moment.MomentInput) => ({
    start: moment(date).format('YYYY-MM-DD'),
    end: moment(date).format('YYYY-MM-DD')
  })
}

export type DefaultRanges = keyof typeof defaultRanges